module.exports = __webpack_public_path__ + "img/mo_grade2.406b9e54.png";